import { render, staticRenderFns } from "./DPCProviders.vue?vue&type=template&id=713121e6&"
import script from "./DPCProviders.vue?vue&type=script&lang=js&"
export * from "./DPCProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports